import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { Modal } from 'antd';
import Button from 'components/Button/Button';
import RestaurantMultipleSelect from './RestaurantMultipleSelect/RestaurantMultipleSelect';
import { IPushesViewContext, PushesViewContext } from '../../../pushesViewContext/pushesViewState/pushesViewContext';
import classNames from 'classnames';
import style from './AdditionalModal.module.scss';

interface IAdditionalModal {
	isVisible: boolean;
}

const AdditionalModal: React.FC<IAdditionalModal> = ({ isVisible }) => {
	const { changeTypeOfModalWindow, setRestaurantsForPush, restaurantsForPush } =
		useContext<IPushesViewContext>(PushesViewContext);

	const buttonWrapperClasses = classNames(style.buttonWrapper, {
		[style.visible]: restaurantsForPush.length,
	});

	const handleSave = async () => {
		changeTypeOfModalWindow('confirm');
	};

	const closeModal = () => {
		changeTypeOfModalWindow(null);
		setRestaurantsForPush([]);
	};

	return (
		<Modal
			bodyStyle={{ padding: '24px 0 0 0' }}
			className={style.modalContainer}
			visible={isVisible}
			onCancel={closeModal}
			width="50%"
			closeIcon={
				<svg className={style.closeIcon}>
					<use xlinkHref={`${breadcrumbs}#crossMark`} />
				</svg>
			}
			centered={true}
			destroyOnClose={true}
			footer={null}
			data-test="AdditionalRestaurantsModal">
			<div className={style.container}>
				<Text
					translationNameSpace="form"
					translationKey="selectRestaurantToSendPushTitle"
					size="xxl"
					weight="bold"
					align="center"
				/>
				<div className={style.fieldWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<RestaurantMultipleSelect isVisibleAdditionalModal={isVisible} />
				</div>
				<div className={buttonWrapperClasses}>
					<Button
						className={style.cancelButton}
						theme="outlined"
						onClick={closeModal}
						icon={
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#resetIcon`} />
							</svg>
						}>
						<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
					</Button>
					<Button className={style.okButton} theme="primaryBlue" onClick={handleSave}>
						<Text translationNameSpace="form" translationKey="okButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default AdditionalModal;
